export class MemoryGlobalStatsModel {
  memory: number;
  textureMemory: number;
  geometryMemory: number;
  morphMemory: number;

  downloadSize: number;
  uncompressedGeos: number;
  uncompressedMorphs: number;
  uncompressedTextures: number;

  geometryDownloadTotal = 0;
  textureDownloadTotal = 0;
  jsonDownloadTotal = 0;
}
